import type * as lazyIndex from './lazyIndex';
import type { PrioritizeButtonProps } from './components/PrioritizeButton';
import type { PrioritizeStatusBarProps } from './components/PrioritizeStatusBar';
import type { PriorityViewBarProps } from './components/PriorityViewBar';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "PriorityInbox"*/ './lazyIndex'),
    { name: 'PriorityInbox' }
);

export const PrioritizeButton: LazyComponent<PrioritizeButtonProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PrioritizeButton);

export const PrioritizeStatusBar: LazyComponent<PrioritizeStatusBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PrioritizeStatusBar);

export const PriorityViewBar: LazyComponent<PriorityViewBarProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.PriorityViewBar);

export { shouldShowPrioritizeButton } from './utils/shouldShowPrioritizeButton';
export { shouldUseCustomHighPriorityView } from './utils/shouldUseCustomHighPriorityView';
